import { FC, useCallback, useState } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { tDispatchAction } from "src/redux/types";
import { tRepCategory } from "tmt_api/src/types/types";
import { tValidType, ValidatedTitle } from "./FormInputs";
import { CheckMark2 } from "./NewCheckBox2";

type tMultiCheck = {
  buttonText: string;
  stateInclude: tRepCategory;
  dispatchAction: tDispatchAction;
};

const MultiCheckMark: FC<tMultiCheck> = ({ buttonText, stateInclude, dispatchAction }) => {
  const dispatch = useAppDispatch();
  const rRepCategory = useSelector(({ ApplicationReducer }) =>
    ApplicationReducer.type === "rep" ? ApplicationReducer.category : [],
  );
  const _dispatchHandler = useCallback(() => dispatch(dispatchAction), [dispatch, dispatchAction]);
  return (
    <CheckMark2
      myLeaveSpace={false}
      textStyle={styles.repApplicationTextStyle}
      style={styles.gApplyMultiCheckBoxInnerContainer}
      myText={buttonText}
      myState={rRepCategory.includes(stateInclude)}
      textPlacement="right"
      onPress={_dispatchHandler}
    />
  );
};

const RepApplicationCategoryOptions: FC = () => {
  const [sIsValid, setIsValid] = useState<tValidType>({});
  const rIsShown = useSelector(({ ApplicationReducer }) => ApplicationReducer.isShown);
  const rRepCategory = useSelector(({ ApplicationReducer }) =>
    ApplicationReducer.type === "rep" ? ApplicationReducer.category : [],
  );

  return (
    <View style={styles.gMultiCheckBoxContainer}>
      <ValidatedTitle
        controller={sIsValid}
        setController={setIsValid}
        rules={{ required: { message: "Required" } }}
        isShown={rIsShown}
        value={rRepCategory.length === 0 ? "" : "right"}
        uniqueName="RepCategory"
        myTitle="What category best describes your Brands (select up to 3) *"
        textProps={{ style: styles.P08_01_InputHeader }}
      />
      <View style={styles.gApplyMultiCheckBox}>
        <MultiCheckMark
          buttonText="Beauty & Skin"
          stateInclude="Beauty"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Beauty",
          }}
        />
        <MultiCheckMark
          buttonText="Home Decor"
          stateInclude="HomeDecor"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "HomeDecor",
          }}
        />

        <MultiCheckMark
          buttonText="Interior Design"
          stateInclude="InteriorDesign"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "InteriorDesign",
          }}
        />
        <MultiCheckMark
          buttonText="Apparel & Accessories"
          stateInclude="Accessories"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Accessories",
          }}
        />

        <MultiCheckMark
          buttonText="Fitness & Wellness"
          stateInclude="Wellness"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Wellness",
          }}
        />
        <MultiCheckMark
          buttonText="Publishing"
          stateInclude="Publishing"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Publishing",
          }}
        />

        <MultiCheckMark
          buttonText="Gift & Tabletop"
          stateInclude="Gift"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Gift",
          }}
        />
        <MultiCheckMark
          buttonText="Gourmet"
          stateInclude="Gourmet"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "Gourmet",
          }}
        />

        <MultiCheckMark
          buttonText="General"
          stateInclude="General"
          dispatchAction={{
            type: "TOGGLE_REP_APPLICATION_CATEGORY",
            category: "General",
          }}
        />
      </View>
    </View>
  );
};

export default RepApplicationCategoryOptions;

const styles = StyleSheet.create({
  P08_01_InputHeader: {
    ...kFonts.formLegend,
  },
  gApplyMultiCheckBox: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
  },
  gApplyMultiCheckBoxInnerContainer: {
    flexDirection: "row",
    marginTop: 6 * kStyleConst.kSpacing,
    width: kStyleConst.kApplyMinWidth,
  },
  gMultiCheckBoxContainer: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  repApplicationTextStyle: {
    marginLeft: 2 * kStyleConst.kSpacing,
  },
});
